import { GlBadge, GlLink, GlPopover } from '../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { uniqueId } from 'lodash-es';
import { helpPagePath } from '~/helpers/help_page_helper';
import { typeConfig, statusConfig } from 'ee_else_ce/commit/constants';
import X509CertificateDetails from './x509_certificate_details.vue';
export default {
    name: 'SignatureBadge',
    components: {
        GlBadge,
        GlPopover,
        GlLink,
        X509CertificateDetails
    },
    props: {
        signature: {
            type: Object,
            required: true
        },
        dataTestid: {
            type: String,
            required: false,
            default: 'signature-badge'
        }
    },
    data () {
        return {
            popoverTarget: uniqueId('signature-badge-')
        };
    },
    computed: {
        statusConfig () {
            return this.$options.statusConfig?.[this.signature?.verificationStatus];
        },
        typeConfig () {
            // eslint-disable-next-line no-underscore-dangle
            return this.$options.typeConfig?.[this.signature?.__typename];
        }
    },
    methods: {
        helpPagePath,
        getSubjectKeyIdentifierToDisplay (subjectKeyIdentifier) {
            // we need to remove : to not trigger secret detection scan
            return subjectKeyIdentifier.replaceAll(':', ' ');
        }
    },
    typeConfig,
    statusConfig
};
